export const messages = {
  en: {
    goldBuyCartManage: {
      title: 'Purchase Records',
      transactionNumber: 'Transaction No.',
      merchantName: 'Merchant Name',
      amount: 'Amount',
      quantity: 'Quantity',
      goldType: 'Gold Type',
      buyer: 'Buyer',
      purchaseTime: 'Purchase Time',
      remark: 'Remark'
    }
  },
  zh: {
    goldBuyCartManage: {
      title: '购买记录',
      transactionNumber: '交易编号',
      merchantName: '商户名称',
      amount: '金额',
      quantity: '数量',
      goldType: '金币类型',
      buyer: '购买人',
      purchaseTime: '购买时间',
      remark: '备注'
    }
  }
}